import axios from "axios";

export default {
    data() {
        return {
            positions: [],
        };
    },
    methods: {
        getPosition() {
            if (!navigator.geolocation) {
                console.error("Geolocation is not supported by this browser.");
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    const time = new Date().toISOString();
                    let ip = document.querySelector('[name="ip"]').value;

                    this.positions.push({
                        lat: lat,
                        lng: lng,
                        time: time,
                        ip: ip,
                    });
                },
                (err) => {
                    console.log(err);
                },
                { enableHighAccuracy: true }
            );
        },
        storePosition(type) {
            axios.post(`/api/maps/${this.mapData.id}/heatmaps/${type}`, this.positions)
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        handlePositionHeatMap(type) {
            setInterval(() => {
                this.getPosition();
            }, 5000);

            window.addEventListener('beforeunload', () => {
                this.storePosition(type);
            });
        },

    },
};
